/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import {
  HeadingContainer, StatsGraphHeading, NoResultsHeading, LoadingSpinner,
} from '../Styles';
import DateFilterDropdown from '../DateFilterDropdown';
import PieChartGraph from '../PieChart';

import useStrings from '../../../../hooks/useStrings';
import { useGetDonationsByAge } from '../../../../lib/graphql/queries';
import { fromDate } from '../../../../lib/Utils';

const TopCharities: React.FC<TopCharitiesProps> = () => {
  const [{ Statistics: strings }] = useStrings();

  const [showDateFilter, setShowDateFilter] = useState(false);
  const [filterSelected, setFilterSelected] = useState<'week' | 'month' | 'year'>('week');

  const { data: donationsByAgeData, loading } = useGetDonationsByAge({
    variables: { fromDate: fromDate(filterSelected) },
  });
  const donationsByAge = donationsByAgeData?.donationsByAge
    .donationsByAgeBracket?.map((bracket) => ({
      name: bracket.AgeBracket, value: bracket.TotalDonated,
    })) || [];

  return (
    <>
      <HeadingContainer>
        <StatsGraphHeading>{strings.donationsByAge}</StatsGraphHeading>
        <DateFilterDropdown
          onToggleDropdown={() => setShowDateFilter(!showDateFilter)}
          isDropdownShown={showDateFilter}
          onClickFilter={setFilterSelected}
          filterSelected={filterSelected}
        />
      </HeadingContainer>
      {loading
        ? <LoadingSpinner />
        : donationsByAge.length === 0
          ? <NoResultsHeading>{strings.noResults}</NoResultsHeading>
          : <PieChartGraph data={donationsByAge} />}
    </>
  );
};

interface TopCharitiesProps { }

export default TopCharities;
